import { CustomFlowbiteTheme, Modal } from "flowbite-react";
import { CadastroContato } from "./components/cadastro-contato";
import { Tabulacao } from "./components/tabulacao";
import { ErroAcordo } from "./components/erro-acordo";
// import { RetirarTabulacao } from "./components/retirar-tabulacao";
import { ProximoAtendimento } from "./components/proximo-atendimento";
import { AddTelefone } from './components/addTelefone'
import { BuscarDevedor } from './components/busca-devedor'
import { PausasHibrido } from './components/pausas-hibrido'
import { PausasHibridoExpert } from './components/pausas-hibrido-expert'
import { DiscadorSelects } from './components/discador-selects'
import { AtualizaUsuario } from './components/suporte/atualiza-usuario'

interface GenericModalProps {
  title: string;
  type: string;
  modalType: string;
  show: boolean;
  isToSave?: boolean;
  onClose: () => void;
  isHibrido?: boolean
  isOperador?: boolean
  app?: string
}

export const GenericModal = ({
  title,
  type,
  onClose,
  show,
  modalType,
  isToSave,
  isHibrido,
  isOperador,
  app
}: GenericModalProps) => {
  const themeModal: CustomFlowbiteTheme['modal'] = {
    root: {
      base: `fixed top-0 right-0 left-0 ${modalType === 'Buscar Devedor' || modalType === 'Pausas Hibrido' ? 'z-50' : 'z-30'} h-modal h-screen overflow-y-auto overflow-x-hidden md:inset-0 md:h-full`
    },
    header: {
      base: 'flex items-start justify-between rounded-t p-5',
      popup: 'p-2 border-0'
    }
  }
  return (
    <>
      <Modal
        onClose={() => onClose()}
        show={show}
        popup={true}

        size={
          type === "Horário"
            ? "3xl"
            : modalType === "Erro Acordo" || modalType === "RetirarTabulacao" || modalType === 'Buscar Devedor' || modalType === 'Pausas Hibrido'
              ? "md"
              : "2xl"
        }
        theme={themeModal}
      >
        <Modal.Header />
        <Modal.Body>
          {modalType === "Cadastro Contato" && (
            <CadastroContato title={title} type={type} isToSave={isToSave} app={app} />
          )}
          {modalType === "Erro Acordo" && <ErroAcordo />}
          {modalType === "Tabulação" && <Tabulacao isHibrido={isHibrido} isOperador={isOperador} app={app} />}
          {/* {modalType === "RetirarTabulacao" && <RetirarTabulacao />} */}
          {modalType === "Proximo Atendimento" && <ProximoAtendimento />}
          {modalType === 'Chat Contato' && <AddTelefone isHibrido={isHibrido} />}
          {modalType === 'Buscar Devedor' && <BuscarDevedor />}
          {modalType === 'Pausas Hibrido' && <PausasHibrido />}
          {modalType === 'Pausas Hibrido Expert' && <PausasHibridoExpert />}
          {modalType === 'Qualificacao Chamada' && <DiscadorSelects automatico={type === 'Automática'} />}
          {modalType === 'Atualiza Usuario' && <AtualizaUsuario />}
        </Modal.Body>
      </Modal>
    </>
  );
};
